export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "pl-PL",
    "Messages": {
        "${copied ? 'Skopiowano' : 'Kopiuj'}": "",
        "${tokenVisibility ? 'Ukryj' : 'Pokaż'} token": "",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "",
        "Administracja": "",
        "Aktywna": "",
        "Aktywne źródła": "",
        "Aktywny": "",
        "Anuluj": "",
        "Bezpieczeństwo": "",
        "Brak wydziału": "",
        "Brak zdefiniowanych zespołów.": "",
        "Bramka SMS": "",
        "Czerwiec": "",
        "Członkowie zespołu": "",
        "Data do": "",
        "Data dodania": "",
        "Data od": "",
        "Data opuszczenia zespołu": "",
        "Data rozpoczęcia": "",
        "Data utworzenia": "",
        "Data użycia": "",
        "Data wygaśnięcia": "",
        "Data zakończenia": "",
        "Dodaj": "",
        "Dodaj do zespołu": "",
        "Dodaj dział": "",
        "Dodaj token": "",
        "Dodaj zastępstwo": "",
        "Dodaj zespół": "",
        "Dodaj źródło": "",
        "Dodanie działu": "",
        "Dodanie zastępstwa": "",
        "Dodanie zespołu": "",
        "Dodanie źródła": "",
        "Domena": "",
        "Dział aktywny": "",
        "Dział nadrzędny": "",
        "Dział został dodany.": "",
        "Dział został usunięty.": "",
        "Dział został zaktualizowany.": "",
        "Edycja działu": "",
        "Edycja zastępstwa": "",
        "Edycja zespołu": "",
        "Edycja źródła": "",
        "Edytuj": "",
        "Edytuj członka grupy": "",
        "Edytuj wpis": "",
        "Filtr dla synchronizacji działów": "",
        "Filtr dla synchronizacji użytkowników": "",
        "Firebase": "",
        "Firebase config": "",
        "Grudzień": "",
        "Hasło": "",
        "Host": "",
        "Imię": "",
        "Imię i Nazwisko": "",
        "Inspekcja": "",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "",
        "Jeśli pole jest puste, wówczas używana jest wartość domyślna. W przeciwnym wypadku wartość domyślna jest nadpisywana.": "",
        "Język": "",
        "Key": "",
        "Key pair": "",
        "Kolor drugorzędny: %0": "",
        "Kolor icon na panelu z aplikacjami: %0": "",
        "Kolor podstawowy: %0": "",
        "Kolor tekstu aktywnej pozycji menu: %0": "",
        "Kolor tła panelu z aplikacjami: %0": "",
        "Kolory zostały przywrócone.": "",
        "Kolory zostały zapisane.": "",
        "Konta użytkowników zostały przypisane do zespołu": "",
        "Kwiecień": "",
        "LDAPS (LDAP over SSL)": "",
        "Liczba wyników na stronie": "",
        "Lider": "",
        "Lipiec": "",
        "Listopad": "",
        "Login": "",
        "Luty": "",
        "Maj": "",
        "Marzec": "",
        "Miesiąc": "",
        "Moje konto": "",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Nadawca": "",
        "Narzędzie integruje się z platformą Firebase (powiadomienia push)": "",
        "Narzędzie integruje się z platformą SMSAPI.pl": "",
        "Nazwa": "",
        "Nazwa działu": "",
        "Nazwa użytkownika": "",
        "Nazwa zespołu": "",
        "Nazwa źródła": "",
        "Nazwisko": "",
        "Nie": "",
        "Nie masz dostępu do tego modułu": "",
        "Nie można przenosić wierszy pomiędzy gałęziami": "",
        "Nie udało się pobrać listy działów": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy wydziałów": "",
        "Nie udało się pobrać listy zespołów": "",
        "Nie zdefiniowano żadnych ról.": "",
        "Nie znaleziono żadnych użytkowników.": "",
        "np. (&(objectClass=organizationalUnit))": "",
        "np. (&(objectClass=user)": "",
        "Opis": "",
        "Opis zespołu": "",
        "Organizacja": "",
        "Organizacja została usunięta.": "",
        "Osoba zastępowana": "",
        "Osoba zastępująca": "",
        "Paleta kolorów": "",
        "Październik": "",
        "Pole \"Liczba wyników na stronie\" jest wymagane.": "",
        "Port": "",
        "Potwierdzenie usunięcia": "",
        "Powrót": "",
        "Predefiniowane tła panelu z aplikacjami": "",
        "Predefiniowane zestawy kolorów": "",
        "Przetestuj ustawienia Sms": "",
        "Przykład: domena\\użytkownik": "",
        "Przykład: użytkownik": "",
        "Przykład: użytkownik@domena": "",
        "Przypisanie do zespołu": "",
        "Przywróć domyślne": "",
        "Rok": "",
        "Role i uprawnienia": "",
        "Role zespołu": "",
        "Root": "",
        "SenderId": "",
        "Sierpień": "",
        "Strona główna": "",
        "Styczeń": "",
        "System": "",
        "Tak": "",
        "Testowy numer telefonu": "",
        "Token": "",
        "Token został usunięty.": "",
        "Tokeny": "",
        "Tokeny dostępu": "",
        "Twój token": "",
        "Tylko liderzy": "",
        "Typ logowania": "",
        "Uprawnienia": "",
        "Ustawienia": "",
        "Ustawienia konta": "",
        "Ustawienia zostały zapisane.": "",
        "Usuń": "",
        "Usuń dział": "",
        "Usuń z zespołu": "",
        "Utwórz grupy": "",
        "Uwzględnij wydziały podrzędne": "",
        "Użytkownicy": "",
        "Użytkownik": "",
        "Użytkownik jest liderem zespołu": "",
        "Użytkownik nie należy do żadnego zespołu.": "",
        "Użytkownik został dodany do zespołu.": "",
        "W organizacji nie ma jeszcze żadnych działów.": "",
        "W zespole od %0": "",
        "W zespole od %0 do %1": "",
        "Wartość domyślna: (&(objectClass=organizationalUnit))": "",
        "Wartość domyślna: (&(objectClass=user)": "",
        "Wiadomość testowa została wysłana.": "",
        "Wpis został zaktualizowany.": "",
        "Wrzesień": "",
        "Wybierz opcję": "",
        "Wybierz użytkownika": "",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "",
        "Wydział": "",
        "wyszukaj użytkownika...": "",
        "Zablokowany": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "Zamknij": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zastępstwa": "",
        "Zastępstwo wygasło.": "",
        "Zastępstwo wygaśnie za 10 minut.": "",
        "Zastępstwo wygaśnie za 5 minut.": "",
        "Zastępstwo wygaśnie za minutę.": "",
        "Zastępstwo zostało dodane.": "",
        "Zastępstwo zostało usunięte.": "",
        "Zastępstwo zostało zaktualizowane.": "",
        "Zastępuje osobę": "",
        "Zawiera": "",
        "Zespoły": "",
        "Zespół": "",
        "Zespół aktywny": "",
        "Zespół został dodany.": "",
        "Zespół został usunięty.": "",
        "Zespół został zaktualizowany.": "",
        "Zmień widok": "",
        "Zobacz wszystkie zastępstwa": "",
        "Źródła LDAP": "",
        "Źródło aktywne": "",
        "Źródło LDAP zostało dodane.": "",
        "Źródło LDAP zostało zaktualizowane.": "",
        "Źródło zostało usunięte.": ""
    }
};
